
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2024-06-09-react-three-fiber-2-spherical-word-cloud",
      function () {
        return require("private-next-pages/blogs/2024-06-09-react-three-fiber-2-spherical-word-cloud/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2024-06-09-react-three-fiber-2-spherical-word-cloud"])
      });
    }
  